import { useEffect, useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import PostingsWbApi from '../../../../API/shipment/postingsWb-api';
import delete_img from '../../../../assets/media/bucket.svg';
import qr from '../../../../assets/media/icons/qr-code-scan.svg';
import { Row, WhiteBlock } from '../../../../components/Basic/Blocks';
import { Button, ButtonWithTooltip } from '../../../../components/Basic/Buttons';
import { Icon, LinkBlue } from '../../../../components/Basic/Elements';
import { DateInput, Select } from '../../../../components/Basic/Inputs';
import { HeaderTitle, Table, TableCell, TableHeader, TableLine } from '../../../../components/Basic/Table';
import { TextGrey } from '../../../../components/Basic/WrapsStyle';
import { MAP_SKLAD, MAP_WB_SKLAD_NAME, MARKETS_MAP, TO_SUPPLIE, TYPE_BUTTONS } from '../../../../constans';
import { formFullDate, getDateMonth } from '../../../../utils';
import styles from './styles.module.scss';

const width = ['150px', '400px', '130px', '140px', '150px', '180px', '120px', '80px', '200px'];

const InitDate = () => {
  const start = new Date();
  start.setTime(start.getTime() + 24 * 3600000);

  return start;
};

const WbSuppliesPage = () => {
  const { shop, skladName } = useOutletContext();

  const [supplies, setSupplies] = useState([]);
  const [show, setShow] = useState(50);
  const [city, setCity] = useState('Москва');

  const [date, setDate] = useState(InitDate());
  const loadSupplies = async () => {
    let city = { msk: 'Москва', ekb: 'Екатеринбург' }[MAP_WB_SKLAD_NAME[shop]];

    PostingsWbApi.getShipments({ data: { shop: MARKETS_MAP[shop], skladName: MAP_WB_SKLAD_NAME[shop], limit: parseInt(show) } }).then((data) => {
      setSupplies(data.supplies);
    });
  };

  const createNewSupplie = ({ isAll = false, customerType }) => {
    PostingsWbApi.createShipment({ data: { name: `${getDateMonth(date)} ${MAP_SKLAD[MAP_WB_SKLAD_NAME[shop]]}${MAP_SKLAD[MAP_WB_SKLAD_NAME[shop]] === 'Москва' ? ' Истра' : ''}`, shop: isAll ? undefined : MARKETS_MAP[shop], customerType } }).then((r) =>
      loadSupplies(),
    );
  };

  const onDelete = (id) => {
    PostingsWbApi.deleteShipment({ data: { supplyId: id, shop: MARKETS_MAP[shop] } }).then((r) => loadSupplies());
  };

  const onShip = (id) => {
    PostingsWbApi.shipSupply({ data: { supplyId: id, shop: MARKETS_MAP[shop] } }).then((r) => loadSupplies());
  };

  useEffect(() => {
    loadSupplies();
  }, [shop, show]);

  return (
    <>
      <WhiteBlock>
        <Row style={{}}>
          <div style={{ marginRight: '40px' }}>
            <Select
              label="Город отгрузки"
              select={MAP_SKLAD[MAP_WB_SKLAD_NAME[shop]]}
              list={['Москва', 'Екатеринбург']}
              disabled={true}
              onSelect={(v) => setCity(v)}
              width="150px"
            />
          </div>
          <div style={{ margin: '-10px 20px 0px 0px' }}>
            <DateInput
              label="Дата отгрузки"
              value={date}
              onChange={(v) => setDate(new Date(v))}
              // classNameCalendar={styles.data}
              width={'140px'}
            />
          </div>
          <Button type={TYPE_BUTTONS.BLUE} style={{ marginRight: '20px' }} onClick={() => createNewSupplie({ customerType: 'физЛица' })}>
            Создать поставку
          </Button>
          <Button type={TYPE_BUTTONS.BLUE} style={{ marginRight: '20px' }} onClick={() => createNewSupplie({ customerType: 'юрЛица' })}>
            Создать поставку для юрЛиц
          </Button>
          <Button type={TYPE_BUTTONS.BLUE} onClick={() => createNewSupplie({ isAll: true })}>
            {`Создать все для города ${MAP_SKLAD[MAP_WB_SKLAD_NAME[shop]]}`}
          </Button>
        </Row>
      </WhiteBlock>

      <Table styles={styles.ozon_table}>
        <TableHeader whiteHeader={true} styles={styles.table_line}>
          <HeaderTitle width="30px" noBorder />
          <HeaderTitle width={width[5]}>Название поставки</HeaderTitle>
          <HeaderTitle width={width[0]}>Номер поставки</HeaderTitle>
          <HeaderTitle width={width[0]}>QR-код поставки</HeaderTitle>
          <HeaderTitle width={width[0]}>Дата создания</HeaderTitle>
          <HeaderTitle width={width[0]}>Статус</HeaderTitle>
          <HeaderTitle width={width[5]}>Время сканирования</HeaderTitle>
          <HeaderTitle width={width[8]} centerText>
            Передать в доставку
          </HeaderTitle>
          <HeaderTitle width={width[7]} centerText>
            QR поставки
          </HeaderTitle>
        </TableHeader>
        {supplies.map((supplie, key) => {
          return (
            <TableLine key={supplie.id}>
              <TableCell width="30px">
                <Row>
                  <div>{key + 1} </div>
                  <div className={styles.wrapper}></div>
                </Row>
              </TableCell>
              <TableCell width={width[5]}>{supplie.name}</TableCell>
              <TableCell width={width[0]} minWidth={width[0]}>
                {supplie.id}
              </TableCell>
              <TableCell width={width[0]}>
                <LinkBlue style={{ fontSize: 14 }} to={TO_SUPPLIE(shop, supplie.id)}>
                  {supplie.id}
                </LinkBlue>
              </TableCell>
              <TableCell width={width[0]}>{formFullDate(supplie.createdAt)}</TableCell>
              <TableCell width={width[0]}>
                {supplie.closedAt === null && <TextGrey className={styles.on_sklad}>На складе</TextGrey>}
                {supplie.closedAt && supplie.scanDt === null && (
                  <TextGrey className={styles.in_delivery}>В пути</TextGrey>
                )}
                {supplie.closedAt && supplie.scanDt && supplie.done && (
                  <TextGrey className={styles.shipped}>Отгружена</TextGrey>
                )}
              </TableCell>
              <TableCell width={width[5]}>{formFullDate(supplie.scanDt)}</TableCell>
              <TableCell width={width[8]}>
                <Button
                  type={TYPE_BUTTONS.WHITE}
                  disabled={supplie.closedAt !== null}
                  onClick={() => onShip(supplie.id)}
                >
                  Передать в доставку
                </Button>
              </TableCell>
              <TableCell width={width[7]} center={true}>
                <Button
                  onClick={() => PostingsWbApi.loadShipmentBarcode({
                    data: {
                      supplyId: supplie.id,
                      shop: MARKETS_MAP[shop],
                      city: { msk: 'Москва', ekb: 'Екатеринбург' }[MAP_WB_SKLAD_NAME[shop]],
                    }
                  })}
                  style={{ padding: 0, marginRight: '15px' }}
                >
                  <Icon src={qr} width="35px" />
                </Button>
              </TableCell>

              <TableCell width={width[7]} center>
                {supplie.closedAt === null && (
                  <ButtonWithTooltip tooltip={`Удалить поставку ${supplie.id}`} onClick={() => onDelete(supplie.id)}>
                    <Icon src={delete_img} width={'20px'} />
                  </ButtonWithTooltip>
                )}
              </TableCell>
            </TableLine>
          );
        })}
      </Table>
    </>
  );
};

export default WbSuppliesPage;
